import { render } from "./EditTaskDescriptionModal.vue?vue&type=template&id=517a5ce2&scoped=true"
import script from "./EditTaskDescriptionModal.vue?vue&type=script&lang=js"
export * from "./EditTaskDescriptionModal.vue?vue&type=script&lang=js"

import "./EditTaskDescriptionModal.vue?vue&type=style&index=0&id=517a5ce2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517a5ce2"]])

export default __exports__